import { render, staticRenderFns } from "./StatResidence.vue?vue&type=template&id=c685942a&"
import script from "./StatResidence.vue?vue&type=script&lang=js&"
export * from "./StatResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports